module.exports = __webpack_public_path__ + "img/left_highlight.ef67e3d1.png";